export default {
  app: {
    privacy: {
      policy: 'kebijakan privasi',
      expansive: 'Dengan menggunakan Expansive, Anda menyetujui {action} Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sesi berakhir',
    sessionExpiredDescription:
      'Sesi Anda telah berakhir. Silakan masuk kembali untuk melanjutkan penggunaan aplikasi.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Pilih bahasa',
      chooseLanguageDescription:
        'Pilih bahasa yang Anda inginkan untuk aplikasi. Ini akan mengubah bahasa antarmuka dan konten.',
    },
    userSelection: {
      cancel: 'Batal',
      createNewUser: 'Nama mereka tidak terdaftar',
      newUser: 'Pengguna baru',
      selectAnExistingUser: 'Pilih pengguna yang sudah ada',
      selectUserHint: 'Pilih pengguna yang sudah ada atau buat baru untuk melanjutkan.',
      startTypingToSearch: 'Mulai mengetik...',
    },
    verification: {
      codeVerification: {
        continue: 'Lanjutkan',
        header: 'Masukkan kode akses lokasi',
        invalidCode: 'Kode tidak valid, silakan coba lagi.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Lanjutkan tanpa verifikasi lokasi',
        enterSiteAccessCode: 'Masukkan kode akses lokasi',
        locationNotEnabledOrAvailable: 'Mengapa saya melihat ini?',
        notAvailable: {
          description: 'Lokasi GPS tidak didukung pada perangkat ini.',
          header: 'Lokasi tidak didukung',
        },
        notEnabled: {
          description: 'Layanan lokasi tidak diaktifkan atau izin tidak diberikan.',
          header: 'Lokasi tidak diaktifkan',
        },
        notVerified: {
          description: 'GPS menunjukkan Anda tidak berada di lokasi.',
          header: 'Lokasi tidak terverifikasi',
        },
        tryAgain: 'Coba lagi',
        unavailable: {
          description: 'Kami tidak dapat memverifikasi lokasi GPS Anda.',
          header: 'Lokasi tidak tersedia',
        },
        unknown: {
          description: 'Kami tidak dapat menentukan lokasi Anda.',
          header: 'Lokasi tidak diketahui',
        },
        verified: {
          description: 'GPS menunjukkan Anda berada di lokasi.',
          header: 'Lokasi terverifikasi',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Tidak ada aset ditemukan',
        emptyDescription: 'Tidak ada aset yang terkait dengan perintah kerja ini.',
        warrantyParts: 'Garansi suku cadang berakhir',
        serialNumber: 'Nomor seri',
        none: '<tidak ada>',
      },
      updates: {
        emptyTitle: 'Tidak ada pembaruan ditemukan',
        emptyDescription: 'Tidak ada pembaruan untuk perintah kerja ini.',
        unknownUser: 'Pengguna tidak dikenal',
        none: 'Tidak ada',
        addComment: {
          buttonLabel: 'Tambah komentar',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Bahaya',
          no: 'Tidak',
          yes: 'Ya',
        },
      },
    },
    attachmentsList: {
      attachments: 'Lampiran',
      documents: 'Dokumen',
      siteDocuments: 'Dokumen Lokasi',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Bahaya',
        induction: 'Induksi',
        safeToProceed: 'Aman untuk melanjutkan',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Tanggal jatuh tempo',
        activeSessions: 'Sesi aktif',
        activeSessionsDescription:
          'Anda sudah terdaftar pada perintah kerja berikut. Anda harus keluar dari perintah kerja ini sebelum masuk ke perintah kerja baru.',
        resumeSession: 'Lanjutkan',
        startTime: 'Mulai pada',
        unexpectedErrorTitle: 'Kesalahan tak terduga',
        unexpectedErrorMessage:
          'Terjadi kesalahan tak terduga saat mencoba membuat sesi Anda. Silakan coba lagi nanti.',
        engineerNotFound: 'Teknisi tidak ditemukan',
        engineerNotFoundDescription:
          'Teknisi yang Anda coba daftarkan tidak ditemukan dalam sistem. Silakan hubungi administrator Anda.',
      },
      verification: {
        code: {
          description:
            'Untuk masuk, silakan dapatkan kode 4 digit dari manajer lokasi atau kontak yang ditunjuk.',
        },
        geo: {
          continue: 'Lanjutkan',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Silakan dapatkan kode akses dari manajer situs atau kontak yang ditunjuk untuk menyelesaikan kunjungan Anda.',
            checkOut: 'Keluar',
            completeBeforeLeaving: 'Silakan lengkapi formulir berikut sebelum meninggalkan lokasi.',
            continue: 'Lanjutkan',
            noResolutionSelected: 'Silakan pilih resolusi sebelum melanjutkan.',
            quoteRequired: {
              hint: 'Kunjungan selesai, penawaran akan menyusul',
              label: 'Penawaran diperlukan',
            },
            returnVisitRequired: {
              hint: 'Kami akan kembali lagi untuk menyelesaikan',
              label: 'Kunjungan ulang diperlukan',
            },
            serviceCompleted: {
              hint: 'Tidak ada tindakan lanjutan yang diperlukan',
              label: 'Layanan selesai',
            },
            uploadCheckout: 'Unggah file, foto, atau video',
            visitNotes: 'Catatan kunjungan',
            workOrderResolution: 'Resolusi perintah kerja',
            enterNotes: 'Masukkan catatan di sini...',
            errors: {
              timedOut: 'Waktu habis, melebihi 30 detik. Silakan coba lagi.',
              closingSession: 'Kesalahan saat menutup sesi',
            },
          },
          success: {
            description:
              'Terima kasih telah mengunjungi {site}. | {site} masih memiliki 1 perintah kerja terbuka. | {site} masih memiliki {count} perintah kerja terbuka.',
            endVisit: 'Akhiri kunjungan',
            header: 'Anda berhasil keluar',
            viewWorkOrders: 'Masuk ke perintah kerja lain',
          },
          verification: {
            code: {
              description:
                'Untuk keluar, silakan dapatkan kode 4 digit dari manajer lokasi atau kontak yang ditunjuk.',
              continue: 'Lanjutkan',
            },
            geo: {
              checkOut: 'Keluar',
              continue: 'Lanjutkan',
            },
          },
        },
        detail: {
          assets: 'Aset',
          call: 'Panggil',
          checkOut: 'Keluar',
          closed: 'Ditutup',
          details: 'Rincian',
          dueBy: 'Tanggal jatuh tempo',
          manageEngineers: 'Kelola teknisi',
          notAvailable: 'Tidak tersedia',
          pointOfContact: 'Kontak utama',
          siteAccessTimes: 'Jam akses lokasi',
          siteAccessInstructions: 'Instruksi akses',
          siteAddress: 'Alamat lokasi',
          siteNotes: 'Catatan lokasi',
          siteTelephone: 'Telepon lokasi',
          siteLocation: 'Lokasi situs',
          updates: 'Pembaruan',
          more: 'Lainnya',
          mismatchErrorTitle: 'Kesalahan perintah kerja',
          mismatchErrorMessage:
            'Perintah kerja yang Anda coba akses tidak sesuai dengan yang sedang Anda daftarkan. Silakan periksa perintah kerja Anda dan coba lagi.',
          siteDocuments: 'Dokumen lokasi',
          validFrom: 'Berlaku dari',
          validUntil: 'Berlaku hingga',
          documentName: 'Nama dokumen',
          documentType: 'Jenis dokumen',
          attachments: 'Berkas perintah kerja',
          download: 'Unduh',
          workDetails: 'Rincian pekerjaan',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Tambah teknisi pendamping',
            assistantEngineers: 'Teknisi pendamping',
            description: 'Untuk alasan keamanan, silakan sebutkan nama setiap teknisi di lokasi.',
            editMainEngineer: 'Edit teknisi utama',
            errors: {
              creatingEngineer: 'Kesalahan saat membuat teknisi',
              creatingSession: 'Kesalahan saat membuat sesi',
            },
            header: 'Teknisi di lokasi',
            mainEngineer: 'Teknisi utama',
            newAssistantEngineer: 'Masukkan nama lengkap mereka',
            next: 'Berikutnya',
            removeEngineer: 'Hapus teknisi',
            selectExistingAssistantEngineer: 'Mulai ketik nama mereka',
          },
          index: {
            description: 'Untuk alasan keamanan, silakan sebutkan nama setiap teknisi di lokasi.',
            errorCreatingEngineer: 'Kesalahan saat membuat teknisi, silakan coba lagi.',
            header: 'Teknisi di lokasi',
            hintMainEngineer: 'Masukkan nama lengkap teknisi utama',
            newMainEngineer: 'Teknisi utama baru',
            next: 'Berikutnya',
            selectExistingMainEngineer: 'Pilih teknisi utama yang sudah ada',
            yes: 'Ya',
            no: 'Tidak',
            mainEngineerLabel: 'Apakah Anda teknisi utama?',
          },
        },
        index: {
          callUsOn: 'Hubungi kami di {phoneNumber}',
          description: 'Tidak dapat menemukan yang Anda cari?',
          dueBy: 'Tanggal jatuh tempo',
          header: 'Pilih perintah kerja',
          notAvailable: 'Tidak tersedia',
          searchWorkOrders: 'Cari perintah kerja...',
        },
        manageEngineers: {
          manageEngineers: 'Kelola teknisi',
          notWorking: 'Pekerja tidak aktif',
          pause: 'Jeda',
          resume: 'Lanjutkan',
          workingNow: 'Pekerja aktif',
          startTime: 'Waktu mulai',
          endTime: 'Waktu selesai',
          duration: 'Durasi',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Umpan balik',
            feedbackDescription:
              'Silakan berikan umpan balik tentang perintah kerja untuk membantu kami meningkatkan layanan.',
            feedbackLabel: 'Umpan balik',
            filesLabel: 'Lampiran',
            submissionLabel: 'Kirim umpan balik',
          },
          hazards: {
            back: 'Kembali',
            hazards: 'Bahaya',
            next: 'Berikutnya',
            no: 'Tidak',
            noTasksForHazard: 'Tidak ada tugas untuk bahaya ini.',
            yes: 'Ya',
          },
          induction: {
            continue: 'Lanjutkan',
            induction: 'Induksi',
          },
          index: {
            checkIn: 'Masuk',
            description: 'Silakan lengkapi penilaian risiko berikut untuk pekerjaan yang dipilih.',
            fail: 'Gagal memproses pemeriksaan mulai kerja.',
            haltMessage:
              'Risiko potensial terdeteksi. Silakan hentikan pekerjaan, tinjau pedoman keselamatan, dan hubungi atasan Anda untuk instruksi lebih lanjut.',
            header: 'Pemeriksaan mulai kerja',
            endVisit: 'Akhiri kunjungan',
            leaveFeedback: 'Tinggalkan umpan balik',
          },
          safeToProceed: {
            continue: 'Lanjutkan',
            safeToProceed: 'Aman untuk melanjutkan',
          },
        },
      },
    },
    index: {
      title: 'Selamat datang',
      description: 'Pindai kode QR di lokasi Anda untuk memulai.',
    },
    login: {
      errorTitle: 'Kesalahan tak terduga',
      errorMessage: 'Terjadi kesalahan tak terduga. Silakan coba pindai kode QR lagi.',
    },
    unauthenticated: {
      welcome: {
        title: 'Selamat datang di {site}',
        description:
          'Sebelum kami dapat menampilkan perintah kerja, kami perlu memverifikasi data Anda. Klik tombol di bawah untuk melanjutkan.',
        next: 'Lanjutkan',
      },
      index: {
        errorTitle: 'Kesalahan tak terduga',
        errorMessage: 'Terjadi kesalahan tak terduga. Silakan coba pindai kode QR lagi.',
      },
      contractor: {
        title: 'Anda bekerja untuk siapa?',
        contractor: 'Kontraktor',
        contractorLabel: 'Mulai ketik nama perusahaan Anda',
        contractorHint: 'Anda harus memasukkan minimal 3 karakter untuk melihat hasil',
        defaultSelectPlaceholder: '--Silakan pilih--',
        next: 'Berikutnya',
      },
      user: {
        title: 'Siapa Anda?',
        cancel: 'Batal',
        createNewUserLabel: 'Nama saya tidak terdaftar',
        existingUserLabel: 'Mulai ketik nama Anda',
        existingUserHint: 'Anda harus memasukkan minimal 3 karakter untuk melihat hasil',
        newUserLabel: 'Masukkan nama lengkap Anda',
        next: 'Berikutnya',
        user: 'Pengguna',
      },
      verification: {
        methods: {
          add: {
            add: 'Tambah metode verifikasi',
            defaultSelectPlaceholder: '--Silakan pilih--',
            emailLabel: 'Email',
            existingMethodWarning:
              'Anda sudah memiliki permintaan tertunda untuk metode verifikasi ini yang menunggu persetujuan admin. Menambah yang baru akan menimpanya.',
            method: 'Metode',
            methodLabel: 'Metode',
            mobileCountryHint: 'Silakan pilih kode negara Anda',
            mobileCountryLabel: 'Kode negara ponsel',
            mobileHint: 'Silakan masukkan nomor ponsel Anda',
            mobileLabel: 'Ponsel',
            title: 'Tambah metode verifikasi',
          },
          confirm: {
            confirm: 'Konfirmasi',
            description: 'Silakan konfirmasi metode verifikasi Anda untuk melanjutkan.',
            label: 'Masukkan kode Anda',
            resend: 'Kirim ulang',
            resendPrompt: 'Tidak menerima kode?',
            title: 'Konfirmasi Metode Verifikasi',
          },
          confirmed: {
            description:
              'Anda akan diberi tahu setelah metode verifikasi ini disetujui oleh admin Anda, dan Anda dapat mulai menggunakannya untuk memverifikasi identitas.',
            forceApproval: 'Sampai disetujui, Anda tidak dapat mengakses perintah kerja.',
            nonForceApproval:
              'Sementara itu, Anda dapat terus mengakses perintah kerja dengan akses terbatas.',
            nonForceApprovalButtonLabel: 'Lanjutkan dengan akses terbatas',
            title: 'Menunggu persetujuan',
          },
          addNew: 'Tambah metode verifikasi baru',
          description:
            'Kami perlu memverifikasi identitas Anda untuk memberikan akses penuh ke perintah kerja.',
          email: 'Email',
          hint: 'Kami akan mengirim tautan ke metode verifikasi yang dipilih untuk memberikan akses penuh ke perintah kerja. Jika Anda perlu mengubah metode verifikasi yang ada, silakan hubungi administrator.',
          label: 'Pilih metode verifikasi',
          next: 'Berikutnya',
          pendingHint: 'Menunggu persetujuan dari admin Anda',
          sms: 'SMS',
          title: 'Verifikasi',
        },
        optional: {
          hint: 'Memverifikasi data pengguna Anda akan memberikan akses penuh ke perintah kerja',
          label: 'Apakah Anda ingin memverifikasi data pengguna Anda?',
          next: 'Berikutnya',
          no: 'Tidak',
          noHint:
            'Saya tidak ingin memverifikasi data pengguna dan melanjutkan dengan akses terbatas ke perintah kerja',
          title: 'Verifikasi',
          yes: 'Ya',
          yesHint:
            'Saya ingin memverifikasi data pengguna dan mendapatkan akses penuh ke perintah kerja',
        },
        sent: {
          description:
            'Tautan login telah dikirim ke {identifier}. Silakan klik tautan untuk menyelesaikan login.',
          title: 'Tautan login dikirim',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Kemarin',
      today: 'Hari ini',
      days: {
        monday: 'Senin',
        tuesday: 'Selasa',
        wednesday: 'Rabu',
        thursday: 'Kamis',
        friday: 'Jumat',
        saturday: 'Sabtu',
        sunday: 'Minggu',
      },
      months: {
        january: 'Januari',
        february: 'Februari',
        march: 'Maret',
        april: 'April',
        may: 'Mei',
        june: 'Juni',
        july: 'Juli',
        august: 'Agustus',
        september: 'September',
        october: 'Oktober',
        november: 'November',
        december: 'Desember',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Terjadi kesalahan',
      message: 'Silakan coba pindai kode QR lagi.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Pengguna tidak dikenal',
      },
      none: 'Tidak ada',
      types: {
        stateTransition: 'Status berubah',
        contractorAssigned: 'Kontraktor ditugaskan',
        engineerAssigned: 'Teknisi ditugaskan',
        serviceAssigned: 'Layanan ditugaskan',
        priorityChanged: 'Prioritas diubah',
        actionableDateChanged: 'Tanggal dapat ditindaklanjuti diubah',
        dueDateChanged: 'Tanggal jatuh tempo diubah',
        etaDateChanged: 'Tanggal perkiraan kedatangan diubah',
        spendLimitApproved: 'Batas pengeluaran disetujui',
        spendLimitCancelled: 'Permintaan batas pengeluaran dibatalkan',
        spendLimitRejected: 'Batas pengeluaran ditolak',
        spendLimitRequested: 'Permintaan batas pengeluaran',
        jobSheetUploaded: 'Lembar kerja diunggah',
        slaAlertSent: 'Peringatan SLA waktu kehadiran terlampaui',
        issuedWorkPermit: 'Surat izin kerja diterbitkan',
        requestForServiceSent: 'Permintaan layanan dikirim',
        comment: 'Komentar ditambahkan',
        unknown: 'Peristiwa tidak dikenal',
      },
      labels: {
        actionableDate: 'Tanggal dapat ditindaklanjuti',
        comment: 'Komentar',
        file: 'Berkas',
        contractor: 'Kontraktor',
        dueDate: 'Tanggal jatuh tempo',
        etaDate: 'Tanggal perkiraan kedatangan',
        engineer: 'Teknisi',
        priority: 'Prioritas',
        requestForService: 'Permintaan layanan',
        service: 'Layanan',
        spendLimit: 'Batas pengeluaran',
        status: 'Status',
        workPermit: 'Surat izin kerja',
      },
    },
  },
}
